/**
 * Parses `xp_ranges` strings from getBadgeTiers badges (fallback when min_xp/max_xp missing).
 */
export function parseBadgeXpRange(raw) {
  if (raw == null) return null;
  const s = String(raw)
    .replace(/pts?/gi, "")
    .replace(/[\u2013\u2014]/g, "-")
    .trim();

  if (!s) return null;

  const between = s.match(/^(\d+)\s*-\s*(\d+)\s*$/);
  if (between) {
    const a = Number(between[1]);
    const b = Number(between[2]);
    if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
    return { min: Math.min(a, b), max: Math.max(a, b) };
  }

  const gteNum = s.match(/^>=\s*(\d+)\s*$/);
  if (gteNum) {
    const n = Number(gteNum[1]);
    return Number.isFinite(n) ? { min: n, max: Infinity } : null;
  }

  const gtNum = s.match(/^>\s*(\d+)\s*$/);
  if (gtNum) {
    const n = Number(gtNum[1]);
    return Number.isFinite(n) ? { min: n, max: Infinity } : null;
  }

  const ltNum = s.match(/^<\s*(\d+)\s*$/);
  if (ltNum) {
    const n = Number(ltNum[1]);
    return Number.isFinite(n) ? { min: -Infinity, max: n - 1 } : null;
  }

  const hyphenLoose = s.match(/(\d+)\s*-\s*(\d+)/);
  if (hyphenLoose) {
    const a = Number(hyphenLoose[1]);
    const b = Number(hyphenLoose[2]);
    if (Number.isFinite(a) && Number.isFinite(b)) {
      return { min: Math.min(a, b), max: Math.max(a, b) };
    }
  }

  return null;
}

/**
 * Prefer getBadgeTiers `min_xp` / `max_xp`; fall back to xp_ranges string.
 */
export function getBadgeInclusiveXpBounds(badge) {
  if (!badge) return null;
  const minRaw = badge.min_xp;
  const maxRaw = badge.max_xp;
  if (minRaw != null && maxRaw != null) {
    const min = Number(minRaw);
    const max = Number(maxRaw);
    if (Number.isFinite(min) && Number.isFinite(max)) {
      return { min: Math.min(min, max), max: Math.max(min, max) };
    }
  }
  return parseBadgeXpRange(badge.xp_ranges);
}

export function xpFitsBadge(xpValue, badge) {
  const xp = Number(xpValue);
  if (!Number.isFinite(xp)) return false;
  const bounds = getBadgeInclusiveXpBounds(badge);
  if (!bounds) return false;
  return xp >= bounds.min && xp <= bounds.max;
}

/** First badge index whose bounds contain `weekly_xp`, or -1. */
export function findTierIndexForXp(badges, xpValue) {
  if (!Array.isArray(badges)) return -1;
  for (let i = 0; i < badges.length; i++) {
    if (xpFitsBadge(xpValue, badges[i])) return i;
  }
  return -1;
}
